(() => {
  if (window.dripCartFeedback) return;
  window.dripCartFeedback = true;
  const selector = 'form[action*="/cart/add"]';
  const pending = new WeakSet();
  let queue = Promise.resolve();
  let live;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function announce(message) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'drip-cart-status';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.append(live);
    }
    live.textContent = message;
  }
  function flight(button, item) {
    const target = document.getElementById('cart-icon-bubble');
    if (!target || reduced()) return Promise.resolve();
    const start = button.getBoundingClientRect();
    const header = target.closest('sticky-header');
    if (header && typeof header.reveal === 'function') header.reveal();
    const ball = document.createElement('div');
    ball.className = 'drip-cart-ball';
    ball.setAttribute('aria-hidden', 'true');
    const src = item?.featured_image?.url || item?.image;
    if (src) {
      const img = document.createElement('img');
      img.alt = '';
      img.src = src;
      img.onerror = () => img.remove();
      ball.append(img);
    }
    ball.style.transform = `translate3d(${start.left + start.width / 2 - 20}px,${start.top + start.height / 2 - 20}px,0)`;
    document.body.append(ball);
    const sx = start.left + start.width / 2;
    const sy = start.top + start.height / 2;
    return new Promise(resolve => {
      let began;
      function frame(now) {
        began ??= now;
        const elapsed = Math.min((now - began) / 800, 1);
        const t = elapsed * elapsed * (3 - 2 * elapsed);
        const end = target.getBoundingClientRect();
        const ex = end.left + end.width / 2;
        const ey = end.top + end.height / 2;
        const cx = sx + (ex - sx) * 0.18;
        const cy = Math.min(sy, ey) - Math.min(140, Math.abs(ex - sx) * 0.2 + 60);
        const x = (1-t)**2*sx + 2*(1-t)*t*cx + t*t*ex;
        const y = (1-t)**2*sy + 2*(1-t)*t*cy + t*t*ey;
        ball.style.transform = `translate3d(${x-20}px,${y-20}px,0) scale(${1-t*0.45})`;
        if (elapsed < 1 && !reduced()) requestAnimationFrame(frame);
        else { ball.remove(); resolve(); }
      }
      requestAnimationFrame(frame);
    });
  }
  function bounce() {
    const icon = document.querySelector('#cart-icon-bubble svg');
    if (icon && !reduced()) icon.animate([
      { transform: 'translateY(0)' }, { transform: 'translateY(-5px)', offset: 0.4 },
      { transform: 'translateY(0)' }
    ], { duration: 280, easing: 'ease-out' });
  }
  async function render(response, cart) {
    const ids = cart ? cart.getSectionsToRender().map(s => s.id) : ['cart-icon-bubble'];
    if (!response.sections || ids.some(id => !response.sections[id])) {
      const url = new URL(location.href);
      url.searchParams.set('sections', ids.join(','));
      const result = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!result.ok) throw new Error('No se ha podido actualizar el contador.');
      response.sections = await result.json();
    }
    if (cart) {
      cart.classList.remove('is-empty');
      cart.renderContents(response, false);
    } else {
      const html = response.sections['cart-icon-bubble'];
      const icon = document.getElementById('cart-icon-bubble');
      const replacement = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (icon && replacement) icon.innerHTML = replacement.innerHTML;
    }
    document.dispatchEvent(new Event('ajax-cart:changed'));
  }
  function submit(form, button, providedData) {
    if (pending.has(form) || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;
    const data = providedData || new FormData(form);
    if (!data.get('id') && !data.get('items[0][id]')) return;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const ids = cart ? cart.getSectionsToRender().map(s => s.id) : ['cart-icon-bubble'];
    data.set('sections', ids.join(','));
    data.set('sections_url', location.pathname);
    pending.add(form);
    const priorDisabled = button.disabled;
    const priorAria = button.getAttribute('aria-disabled');
    const label = button.querySelector('.ecom-add-to-cart-text') || button.querySelector('span:not(.loading__spinner):not(.sold-out-message)') || button;
    const labels = button.matches('.qsc2-stickybar__action-btn') ? Array.from(button.querySelectorAll('.qsc2-stickybar__action-label,.qsc2-stickybar__action-name--desktop')) : [label];
    const originals = labels.map(node => node.textContent);
    const errors = form.parentElement.querySelector('[data-drip-cart-error]');
    errors?.remove();
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    announce('Añadiendo producto…');
    const task = async () => {
      let added = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const result = await fetch(`${root}cart/add.js?sc-silently-change-cart=true`, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
        });
        const response = await result.json();
        if (!result.ok || response.status) throw new Error(response.description || response.message || 'No se ha podido añadir el producto.');
        added = true;
        labels.forEach(node => { node.textContent = '✓ AÑADIDO'; });
        button.removeAttribute('aria-busy');
        announce('Producto añadido al carrito.');
        const restore = new Promise(resolve => setTimeout(() => {
          labels.forEach((node, index) => { if (node.textContent === '✓ AÑADIDO') node.textContent = originals[index]; });
          resolve();
        }, 1500));
        await flight(button, response.items?.[0] || response);
        await render(response, cart);
        bounce();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drip-cart-feedback', productVariantId: data.get('id'), cartData: response });
        }
        await restore;
      } catch (error) {
        const message = added ? 'Producto añadido. No se ha podido refrescar el carrito; recarga la página antes de volver a añadirlo.' : error.message || 'No se ha podido añadir el producto. Inténtalo de nuevo.';
        const node = document.createElement('p');
        node.dataset.dripCartError = '';
        node.setAttribute('role', 'alert');
        node.textContent = message;
        form.after(node);
        announce(message);
      } finally {
        pending.delete(form);
        button.disabled = priorDisabled;
        if (priorAria === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', priorAria);
        button.removeAttribute('aria-busy');
      }
    };
    queue = queue.then(task, task);
  }
  document.addEventListener('click', event => {
    const sticky = event.target.closest('.qsc2-stickybar__action-btn');
    if (sticky && window.qscStore?.product) {
      const bar = sticky.closest('.qsc2-stickybar');
      const form = document.querySelector(selector);
      const options = Array.from(bar.querySelectorAll('.qsc2-variant-opt__select')).map(select => select.value);
      const variant = window.qscStore.product.variants.find(item => item.options.every((value, index) => value === options[index]));
      if (form && variant) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const data = new FormData(form);
        data.set('id', variant.id);
        data.set('quantity', bar.querySelector('.qsc2-product-item__quantity-input')?.value || '1');
        submit(form, sticky, data);
        return;
      }
    }
    const button = event.target.closest('button[name="add"], input[name="add"][type="submit"], .ecom-product-single__add-to-cart--submit');
    const form = button?.form || button?.closest(selector);
    if (!form?.matches(selector) || button.closest('.shopify-payment-button')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submit(form, button);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches(selector)) return;
    const button = event.submitter || form.querySelector('[name="add"],button[type="submit"]');
    if (!button || button.name === 'checkout' || button.closest('.shopify-payment-button') || button.matches('[data-action="buy-now"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submit(form, button);
  }, true);
})();
